import { ReactNode } from "react";
import styles from "./styles.module.scss";

type Props = {
  title: string;
  label: string;
  children: ReactNode;
};
const NoteCodeLayout = ({ title, label, children }: Props) => (
  <div className={styles["note-code-layout"]}>
    <div className={styles["note-code-layout__title"]}>{title}</div>
    <div className={styles["note-code-layout__label"]}>{label}</div>
    {children}
  </div>
);

export default NoteCodeLayout;
